module.exports = __webpack_public_path__ + "static/media/twitter.bfb3b141.svg";